/* tslint:disable */
/* eslint-disable */
/**
 * mindd-stim3-home-api-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const PrescriptionStatus = {
    Waiting: 'WAITING',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED'
} as const;

export type PrescriptionStatus = typeof PrescriptionStatus[keyof typeof PrescriptionStatus];



